"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var evaluationCell_1 = require("./evaluationCell");
var tripleEstimatesForm_1 = require("./tripleEstimatesForm");
var App_1 = require("../../../App");
var mobx_react_1 = require("mobx-react");
var typestyle_1 = require("typestyle");
var constants_1 = require("../../../constants");
var matrixUtils_1 = require("../../admin/matrixUtils");
var riskTargetsContext_1 = require("../../../context/admin/riskTargetsContext");
var utils_1 = require("../../../utils");
var MatrixColorSvc_1 = require("../../../services/MatrixColorSvc");
var Matrix = (function (_super) {
    __extends(Matrix, _super);
    function Matrix(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickHandler = function (cell_id) {
            App_1.store.risklist.evaluation.current_equals_default().then(function (result) {
                var data = JSON.parse(result);
                if (data.existing_equals_implicit === false) {
                    fancyConfirm(gettext("Are you sure that you want to overwrite the existing evaluation which is based on a manual assessment?"), function () {
                        App_1.store.risklist.evaluation.updateEvaluation(cell_id)
                            .then(function () { return App_1.store.risklist.evaluation.fetchEvaluation(); }).catch(function (error) { return console.log("SERVER ERROR", error); });
                    });
                }
                else {
                    App_1.store.risklist.evaluation.updateEvaluation(cell_id)
                        .then(function () { return App_1.store.risklist.evaluation.fetchEvaluation(); }).catch(function (error) { return console.log("SERVER ERROR", error); });
                }
            }).catch(function (error) { return console.log(error); });
        };
        _this.handleEstimateChange = function (event) {
            var _a = event.currentTarget, name = _a.name, value = _a.value;
            var estimatesCopy = _this.state.estimates.slice();
            var estimateIndex = estimatesCopy.map(function (value) { return value.name; }).indexOf(name);
            var estimateCopy = __assign({}, estimatesCopy[estimateIndex]);
            var is_valid = G$.isNumeric(value);
            estimateCopy.valid = is_valid;
            estimateCopy.value = value;
            estimatesCopy[estimateIndex] = estimateCopy;
            _this.setState({ estimates: estimatesCopy, invalidEstimates: !is_valid });
        };
        _this.handleEvaluateClick = function (event) {
            var estimatesData = {};
            _this.state.estimates.forEach(function (value) {
                estimatesData[value.name] = parseFloat(value.value);
            });
            var frequencies = _this.state.estimates.filter(function (value) { return value.type == 'freq'; });
            var valid_frequencies = _this.validate_estimates(frequencies);
            _this.setState({
                invalidFrequencies: !valid_frequencies
            });
            var consequences = _this.state.estimates.filter(function (value) { return value.type == 'cons'; });
            var valid_consequences = _this.validate_estimates(consequences);
            _this.setState({
                invalidConsequences: !valid_consequences
            });
            if (valid_frequencies && valid_consequences) {
                App_1.store.risklist.evaluation.get_eval_cell(estimatesData).then(function () {
                    App_1.store.risklist.evaluation.updateEstimates(estimatesData).then(function () {
                        App_1.store.risklist.evaluation.fetchEvaluation();
                    });
                });
            }
            else {
                notification(gettext("Error: Triple estimate intervals must be valid") + ".", {
                    type: "error",
                });
            }
        };
        var evaluation = _this.evaluationByEType(_this.props.data.evaluations, constants_1.EvaluationTypeChoices.PRESENT);
        _this.state = {
            evaluation_type: props.evaluation_type,
            estimates: _this.getEstimates(evaluation),
            fmean: evaluation ? evaluation.formatted_fmean : 0,
            cmean: evaluation ? evaluation.formatted_cmean : 0,
            var: evaluation ? evaluation.formatted_explicit_var : 0,
            invalidEstimates: false,
            invalidFrequencies: false,
            invalidConsequences: false,
        };
        return _this;
    }
    Matrix.prototype.evaluationByEType = function (evaluations, etype) {
        return evaluations[constants_1.EvaluationTypeChoices.asDict()[etype]];
    };
    Matrix.prototype.getEstimates = function (evaluation) {
        return [{
                name: 'freq_low',
                value: evaluation && (evaluation.freq_low || evaluation.freq_low === 0) ? evaluation.freq_low.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'freq_mid',
                value: evaluation && (evaluation.freq_mid || evaluation.freq_mid === 0) ? evaluation.freq_mid.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'freq_high',
                value: evaluation && (evaluation.freq_high || evaluation.freq_high === 0) ? evaluation.freq_high.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'cons_low',
                value: evaluation && (evaluation.cons_low || evaluation.cons_low === 0) ? evaluation.cons_low.toString() : '',
                valid: true,
                type: 'cons'
            }, {
                name: 'cons_mid',
                value: evaluation && (evaluation.cons_mid || evaluation.cons_mid === 0) ? evaluation.cons_mid.toString() : '',
                valid: true,
                type: 'cons'
            }, {
                name: 'cons_high',
                value: evaluation && (evaluation.cons_high || evaluation.cons_high === 0) ? evaluation.cons_high.toString() : '',
                valid: true,
                type: 'cons'
            }];
    };
    Matrix.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
        if (prevProps.data.evaluations != this.props.data.evaluations) {
            var evaluation = this.evaluationByEType(this.props.data.evaluations, this.state.evaluation_type);
            this.setState({
                estimates: this.getEstimates(evaluation),
                fmean: evaluation ? evaluation.formatted_fmean : 0,
                cmean: evaluation ? evaluation.formatted_cmean : 0,
                var: evaluation ? evaluation.formatted_explicit_var : 0,
                invalidEstimates: false,
                invalidFrequencies: false,
                invalidConsequences: false
            });
        }
    };
    Matrix.prototype.validate_estimates = function (estimates) {
        var is_valid = true;
        for (var i = 0; i < estimates.length - 1; i++) {
            if (parseFloat(estimates[i].value) > parseFloat(estimates[i + 1].value)) {
                is_valid = false;
                break;
            }
        }
        return is_valid;
    };
    Matrix.prototype.onEvalTypeChange = function (eval_type) {
        var etype = Number(eval_type);
        if (constants_1.EvaluationTypeChoices.toList().includes(etype)) {
            var evaluation = this.evaluationByEType(this.props.data.evaluations, etype);
            this.setState({
                evaluation_type: etype,
                estimates: this.getEstimates(evaluation),
                fmean: evaluation ? evaluation.formatted_fmean : 0,
                cmean: evaluation ? evaluation.formatted_cmean : 0,
                var: evaluation ? evaluation.formatted_explicit_var : 0,
                invalidEstimates: false,
                invalidFrequencies: false,
                invalidConsequences: false,
            });
            App_1.store.risklist.evaluation.setEtype(etype);
        }
    };
    Matrix.prototype.render = function () {
        var _this = this;
        var base = "Matrix";
        var isOppClass = this.props.data.matrix.is_opportunity ? 'Matrix__Opportunity' : 'Matrix__Risk';
        var tableClassName = (0, typestyle_1.classes)(base, isOppClass);
        var cellRows = (0, utils_1.chunkArray)(this.props.data.matrix.cells, this.props.data.matrix.column_headers.length);
        return (React.createElement(React.Fragment, null,
            this.props.data.matrix.explicit_evaluation && (React.createElement(tripleEstimatesForm_1.default, { estimates: this.state.estimates, fmean: this.state.fmean, cmean: this.state.cmean, var: this.state.var, unit: this.props.data.matrix.risk_target_unit, invalid: this.state.invalidEstimates, invalidFrequencies: this.state.invalidFrequencies, invalidConsequences: this.state.invalidConsequences, change: this.handleEstimateChange, click: this.handleEvaluateClick })),
            React.createElement("label", null,
                gettext("Evaluation type"),
                ": "),
            React.createElement("button", { id: "eval_type_choice_0", className: "btn btn-sm ".concat(this.state.evaluation_type == constants_1.EvaluationTypeChoices.ALL ? "btn-outline-dark" : "btn-link-dark"), onClick: function () { return _this.onEvalTypeChange(constants_1.EvaluationTypeChoices.ALL.toString()); } }, gettext("All")),
            React.createElement("button", { id: "eval_type_choice_10", className: "btn btn-sm ".concat(this.state.evaluation_type == constants_1.EvaluationTypeChoices.GROSS ? "btn-outline-dark" : "btn-link-dark"), onClick: function () { return _this.onEvalTypeChange(constants_1.EvaluationTypeChoices.GROSS.toString()); } }, get_term("Gross")),
            React.createElement("button", { id: "eval_type_choice_20", className: "btn btn-sm ".concat(this.state.evaluation_type == constants_1.EvaluationTypeChoices.PRESENT ? "btn-outline-dark" : "btn-link-dark"), onClick: function () { return _this.onEvalTypeChange(constants_1.EvaluationTypeChoices.PRESENT.toString()); } }, get_term("Present")),
            React.createElement("button", { id: "eval_type_choice_30", className: "btn btn-sm ".concat(this.state.evaluation_type == constants_1.EvaluationTypeChoices.NETT ? "btn-outline-dark" : "btn-link-dark"), onClick: function () { return _this.onEvalTypeChange(constants_1.EvaluationTypeChoices.NETT.toString()); } }, get_term("Nett")),
            React.createElement("table", { className: tableClassName },
                React.createElement("tr", null,
                    React.createElement("th", null, this.props.data.matrix.risk_target_name),
                    this.props.data.matrix.column_headers.map(function (column_header) {
                        var columnDisplayChoice = (0, matrixUtils_1.isConsequence)(column_header) ? _this.props.data.matrix.column_display : _this.props.data.matrix.row_display;
                        return _this.renderColumnHeaderCell(column_header, columnDisplayChoice);
                    })),
                this.props.data.matrix.row_headers.map(function (row_header, i) {
                    var rowDisplayChoice = (0, matrixUtils_1.isFrequency)(row_header) ? _this.props.data.matrix.row_display : _this.props.data.matrix.column_display;
                    return (React.createElement("tr", { key: row_header.id },
                        _this.renderColumnHeaderCell(row_header, rowDisplayChoice),
                        (cellRows[i] || [])
                            .map(function (cell) {
                            var estimates = {
                                freq_low: cell.frequency.low,
                                freq_mid: cell.frequency.mid,
                                freq_high: cell.frequency.high,
                                cons_low: cell.consequence.low,
                                cons_mid: cell.consequence.mid,
                                cons_high: cell.consequence.high
                            };
                            return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
                                var colorChoices = _this.props.data.matrix.is_opportunity ? context.availableOppColorChoices : context.availableRiskColorChoices;
                                var pointerColorChoices = (0, MatrixColorSvc_1.ring_colors_as_choice_list)();
                                var cellColor = (0, matrixUtils_1.getColorChoiceById)(colorChoices, cell.color);
                                if (cellColor !== undefined && pointerColorChoices !== undefined) {
                                    return (React.createElement(evaluationCell_1.default, { key: cell.id, clickHandler: _this.onClickHandler.bind(_this, cell.id), cell: cell, cell_color: (0, matrixUtils_1.getColorChoiceById)(colorChoices, cell.color), pointerColorChoices: pointerColorChoices, evaluations: _this.props.data.evaluations, evaluationByEType: _this.evaluationByEType, explicit_evaluation: _this.props.data.matrix.explicit_evaluation, estimates: estimates }));
                                }
                            }));
                        })));
                }))));
    };
    Matrix.prototype.renderColumnHeaderCell = function (header, rowDisplayChoice) {
        return (React.createElement("th", { className: "MatrixTable__ColumnHeader" },
            React.createElement("span", { className: "MatrixTable__ColumnHeader__Name" }, header.name),
            React.createElement("br", null),
            React.createElement("span", { className: "MatrixTable__ColumnHeader__Desc" }, (0, matrixUtils_1.displayHeader)(header, rowDisplayChoice))));
    };
    Matrix = __decorate([
        mobx_react_1.observer
    ], Matrix);
    return Matrix;
}(React.Component));
exports.default = Matrix;
